
declare let require: any;
import * as cryptoJS from 'crypto-js';

export class Security {

    readonly IV_SIZE: number = 16;
    constructor() { }

    public encryptAES(value: string, key: string): string {
        let iv = cryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
        const ecrypted = cryptoJS.AES.encrypt(JSON.stringify(value), cryptoJS.enc.Utf8.parse(key), { iv });
        return ecrypted.toString();
    }

    public decryptAES(value: string, key: string): string {
        let iv = cryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
        const decrypted = cryptoJS.AES.decrypt(value, cryptoJS.enc.Utf8.parse(key), { iv });

        return decrypted.toString(cryptoJS.enc.Utf8);
    }

    public base64ToString(cadena: string) {
        const words = cryptoJS.enc.Base64.parse(cadena);
        return cryptoJS.enc.Utf8.stringify(words);
    }

}
